export enum DocumentDataType {
    CompletedFormField = 1,
    Service = 2,
    SafetyPoint = 3
}
